import script from "./Import.vue?vue&type=script&setup=true&lang=js"
export * from "./Import.vue?vue&type=script&setup=true&lang=js"

import "./Import.vue?vue&type=style&index=0&id=62e24493&scoped=true&lang=css"
import "./Import.vue?vue&type=style&index=1&id=62e24493&lang=css"

import exportComponent from "/home/runner/work/INPEOPLE-HUB/INPEOPLE-HUB/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62e24493"]])

export default __exports__